module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.pageHealthCare.elements) ? _c('div', {
    staticClass: "landing-healtcare"
  }, [_c('hero', {
    attrs: {
      "props": _vm.pageHealthCare.elements,
      "heroHome": false
    }
  }), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "cases"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row"
  }, [_vm._l((_vm.pageHealthCare.elements.cases.value), function(cases) {
    return [_c('div', {
      staticClass: "case-item col-xs-12 col-md-4"
    }, [_c('div', {
      staticClass: "inner-text"
    }, [_c('div', {
      staticClass: "logo outside"
    }, [_c('h4', [_vm._v(_vm._s(_vm.modularContent[cases].elements.case.value))])]), _vm._v(" "), _c('div', {
      staticClass: "left-content"
    }, [_c('div', {
      staticClass: "logo _inside"
    }, [_c('h4', [_vm._v(_vm._s(_vm.modularContent[cases].elements.case.value))])]), _vm._v(" "), _c('div', {
      staticClass: "info",
      domProps: {
        "innerHTML": _vm._s(_vm.modularContent[cases].elements.text.value)
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "right-content"
    }, [_c('img', {
      staticClass: "o-fit",
      attrs: {
        "src": _vm.modularContent[cases].elements.picture.value[0].url,
        "alt": ""
      }
    })])])])]
  })], 2)])]), _vm._v(" "), _c('section', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "content-articles"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('h2', {
    directives: [{
      name: "in-viewport",
      rawName: "v-in-viewport"
    }],
    staticClass: "text-center"
  }, [_vm._v(_vm._s(_vm.pageHealthCare.elements.title_content.value))]), _vm._v(" "), _c('p', {
    staticClass: "text-center container"
  }, [_vm._v(_vm._s(_vm.pageHealthCare.elements.subtitle_content.value))]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "copy col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-text left-content"
  }, [_c('img', {
    staticClass: "o-fit",
    attrs: {
      "src": _vm.pageHealthCare.elements.image_content.value[0].url,
      "alt": ""
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "detail col-xs-12 col-md-6"
  }, [_c('div', {
    staticClass: "inner-text right-content",
    domProps: {
      "innerHTML": _vm._s(_vm.pageHealthCare.elements.main_content.value)
    }
  })])])])]), _vm._v(" "), _c('contact', {
    attrs: {
      "contactFormInfo": _vm.contactFormInfo
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('section', {
    staticClass: "contact-section"
  }, [_c('div', {
    staticClass: "inside"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "copy col-xs-12 col-md-6 col-lg-8"
  }, [_c('h3', [_vm._v("About Marcus Thomas LLC")]), _vm._v(" "), _c('p', [_vm._v("Marcus Thomas LLC, with 300 professionals in its offices in Cleveland and Cincinnati, Ohio, Buenos Aires, Argentina and Santiago, Chile, is among America’s leading independent advertising agencies. Marcus Thomas is a recognized leader in digital strategy and technology; is Ohio’s largest media planning and buying agency; has been recognized by the Content Marketing Institute as one of the world’s leading content marketing agencies; and is regularly honored for its award-winning creative and social media campaigns.")]), _vm._v(" "), _c('router-link', {
    staticClass: "btn_orange",
    attrs: {
      "to": "/solutions",
      "tag": "button"
    }
  }, [_vm._v("CAPABILITIES")])], 1), _vm._v(" "), _vm._m(0)])])]), _vm._v(" "), _c('Footer')], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "image col-xs-12 col-md-6 col-lg-4"
  }, [_c('img', {
    staticClass: "o-fit",
    attrs: {
      "src": "/dist/about.png",
      "alt": ""
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-666ef829","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/landings/HealthCare.vue
// module id = 1533
// module chunks = 0